export default __webpack_public_path__ + "static/media/Ferro Orbita.f03bdf32.png";